import { Stack } from '@ui-components/neo.tax';

import { RdProject } from '@neo.tax/rd/hooks';
import { KeywordSearch } from '@neo.tax/shared';

import { AddPayrollExpenseButton } from './AddPayrollExpenseButton';

interface RdProjectTeamMembersToolbarProps {
  rdProject: RdProject;
  searchKeyword: string | null;
  setSearchKeyword: React.Dispatch<React.SetStateAction<string | null>>;
}

export const RdProjectTeamMembersToolbar = ({
  rdProject,
  searchKeyword,
  setSearchKeyword,
}: RdProjectTeamMembersToolbarProps): React.ReactElement => (
  <Stack paddingX={4} paddingY={3} gap={6}>
    <KeywordSearch searchKeyword={searchKeyword} setSearchKeyword={setSearchKeyword} />
    <AddPayrollExpenseButton rdProject={rdProject} />
  </Stack>
);
